import { FC, Fragment, useEffect } from 'react';
// Redux
import { useAppDispatch } from 'app/hooks/useStore';
// Async
import { getTeams } from 'app/store/Teams/Teams.async';
// Actions
import { TeamsActions } from 'app/store/Teams/Teams.slice';
// Mui
import { Box, Container, Toolbar, Typography } from '@mui/material';
// 
import TeamsFilter from './TeamsFilter';
import TeamsList from './TeamsList';
import TeamsFab from './TeamsFab';
// i18next
import { useTranslation } from 'react-i18next';

const TeamsPage:FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getTeams({}));

    return () => {
      dispatch(TeamsActions.setInitialField('filter'));
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <Toolbar variant="dense">
        <Typography variant="h6">{t('pages.teams.title')}</Typography>
      </Toolbar>
      <Box sx={{ flexGrow: 1, overflowY: 'auto' }} react-action="scroll">
        <Container sx={{ pt: 4, pb: 20 }} maxWidth="sm">
          <TeamsFilter />
          <TeamsList />
        </Container>
      </Box>
      <TeamsFab />
    </Fragment>
  )
}

export default TeamsPage;
